import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import { updateCompanyInformation } from '../service/companyInformationService'
import companyInformationQueryKeys from './companyInformationQueryKeys'
import { CompanyInformationData } from '../types'

export const useUpdateCompanyInformation = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (stakeholders: CompanyInformationData['stakeholders']) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return updateCompanyInformation(stakeholders, companyId)
    },
    onSuccess: updated => {
      queryClient.setQueryData(companyInformationQueryKeys.detail({ companyId }), updated)
    }
  })
}
